import { render, staticRenderFns } from "./templateEditor.vue?vue&type=template&id=009f4924&scoped=true"
import script from "./templateEditor.vue?vue&type=script&lang=js"
export * from "./templateEditor.vue?vue&type=script&lang=js"
import style0 from "./templateEditor.vue?vue&type=style&index=0&id=009f4924&prod&lang=scss"
import style1 from "./templateEditor.vue?vue&type=style&index=1&id=009f4924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009f4924",
  null
  
)

export default component.exports